import { useAtom } from "jotai";
import { dialogsAtom } from "./useDialogBetter";

export function DialogsDisplay({ children }) {
    const [dialogs, setDialogs] = useAtom(dialogsAtom);

    return (
        <>
            {children}
            {dialogs.map((dialog) => {
                const { Component, props, id } = dialog;
                return (
                    <Component
                        key={id}
                        {...props}
                        // To handle already created MUI dialogs
                        open={dialog.open}
                        // To handle already created MUI dialogs
                        onClose={dialog.onClose}
                    />
                );
            })}
        </>
    );
}
